import { useBrand } from "./BrandProvider";
import { useTheme } from "./ThemeProvider";
import { productSigils } from "../data/productSigils";
import { Logo } from "./Logo";
import { ProductSigilIcon } from "./ProductSigilIcon";

interface SidebarBrandLogoProps {
  isCollapsed: boolean;
}

export function SidebarBrandLogo({ isCollapsed }: SidebarBrandLogoProps) {
  const { brand } = useBrand();
  const { theme } = useTheme();
  const product = productSigils.find((p) => p.slug === brand);

  // ── Collapsed: logomark only ──────────────────────────────────────────
  if (isCollapsed) {
    if (product?.horizontalLogoDark) {
      return (
        <div className="flex justify-center">
          <ProductSigilIcon
            slug={brand}
            className="w-8 h-8"
            accentColor={product.accentColor}
            isActive
          />
        </div>
      );
    }
    // EngageXP fallback
    return (
      <div className="flex justify-center">
        <Logo variant="logomark" colorScheme="purple" size={32} />
      </div>
    );
  }

  // ── Expanded: product horizontal logo ────────────────────────────────
  if (product?.horizontalLogoLight && product?.horizontalLogoDark) {
    const logoSrc = theme === "dark" ? product.horizontalLogoDark : product.horizontalLogoLight;
    return (
      <div className="flex justify-center">
        <img
          src={logoSrc}
          alt={`${product.name} logo`}
          className="h-8 w-auto max-w-full"
        />
      </div>
    );
  }

  // ── Expanded: EngageXP default — purple Logo + "SIGIL" label ─────────
  return (
    <>
      <div className="flex justify-center">
        <Logo variant="horizontal" colorScheme="purple" size={140} />
      </div>
      <p className="mt-2 exp-small tracking-[3px] uppercase opacity-50 text-center">
        SIGIL
      </p>
    </>
  );
}
